const disable = () => {
  document.body.style.overflow = "hidden";
};

const enable = () => {
  document.body.style.overflow = "auto";
};

export default { enable, disable };
